import Header from './components/header';
import Hero from './components/hero';
import Technology from './components/technology';
import EMPDefense from './components/EMPDefense';
import Applications from './components/Applications';
import Investment from './components/investment';
import Team from './components/team';
import Footer from './components/footer';




function App() {
  return (
    <div>
      <Header />
      <Hero />
      <Technology />
      <EMPDefense />
      <Applications />
      <Investment />
      <Team />
      <Footer/>
    </div>
  );
}

export default App;